export default __webpack_public_path__ + "static/media/register.01849878.jpg";